import React from 'react';
import './css/loader.css';

const Loader = () => (
    <div className="loader-overlay">
        <div className="loader-spinner"></div>
    </div>
);

export default Loader;
